function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIconDM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/filled/application/mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9pi91vbpja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/application/mail (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/application/mail (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/application/mail",
    style: {
      clipPath: "url(#9pi91vbpja)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/application/mail (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/application/mail (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.563 15.125H.687A.688.688 0 0 1 0 14.438V.687A.688.688 0 0 1 .687 0h17.876a.688.688 0 0 1 .687.687v13.75a.688.688 0 0 1-.687.688zM2.793 2.063a.153.153 0 0 0-.09.029.157.157 0 0 0-.056.076.154.154 0 0 0 .053.172l6.779 5.274a.461.461 0 0 0 .569 0l6.779-5.274a.155.155 0 0 0 .054-.078.161.161 0 0 0 0-.095.157.157 0 0 0-.057-.076.152.152 0 0 0-.09-.029z",
    transform: "translate(1.375 3.438)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconDM);
export default __webpack_public_path__ + "static/media/mailIcon_d_m.2622fa3f61f40f7eb3e65d6195a9ae38.svg";
export { ForwardRef as ReactComponent };